<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="dataSource"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há atas cadastradas"
			hide-default-footer
		>
			<template #item.fornecedor="{ item }">
				<span>
					<texto-tooltip :texto="getFornecedorDescricaoCompleta(item)" :tamanho-maximo="40"></texto-tooltip>
				</span>
			</template>
			<template #item.valorAnterior="{ item }">
				<span v-if="!!item.valorAnterior">
					{{ item.valorAnterior | azCurrency(numeroCasasDecimaisValores) }}
				</span>
			</template>
			<template #item.valorNovo="{ item }">
				<span v-if="!!item.valorNovo">
					{{ item.valorNovo | azCurrency(numeroCasasDecimaisValores) }}
				</span>
			</template>
			<template #item.anexo="{}">
				<a class="">Baixar</a>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			@resetar-page="resetarPage"
			@paginar="setPaginacaoHistorico"
		></paginacao-tabela>
		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, mutationTypes } from '@/core/constants'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'historico-realinhar',
	components: { TextoTooltip },
	props: {
		itemSelecionado: {
			type: Object,
			default() {
				return {}
			},
		},
	},
	data() {
		return {
			dataSource: [],
			colunas: [
				new TabelaColunaUtils('Fornecedor', 'fornecedor', '20%'),
				new TabelaColunaUtils('Valor Anterior', 'valorAnterior', '15%'),
				new TabelaColunaUtils('Novo Valor', 'valorNovo', '15%'),
				new TabelaColunaUtils('Marca Anterior', 'marcaAnterior', '15%'),
				new TabelaColunaUtils('Nova Marca', 'marcaNova', '15%'),
				new TabelaColunaUtils('Motivo', 'motivo', '20%'),
				new TabelaColunaUtils('Anexo', 'anexo', '15%'),
			],
			paginacaoInterna: PaginacaoListagem(['id'], 5, 'DESC'),
			totalPaginas: 0,
			totalItens: 0,
			textos: {
				titulo: 'Não há históricos por aqui',
			},
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
	},
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.setPaginacaoHistorico(novoValor)
			},
			deep: true,
		},
	},
	async mounted() {
		this.resetarPage()
		await this.carregarHistoricos()
	},
	methods: {
		async carregarHistoricos() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.REALINHAMENTO.HISTORICO.BUSCAR_HISTORICOS,
				this.itemSelecionado.id,
			)
			this.dataSource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
			this.carregando = false
		},
		resetarPage() {
			this.$store.commit(mutationTypes.ITEM_ATA.REALINHAMENTO.HISTORICO.RESETAR_PAGINA_LISTAGEM)
		},
		async setPaginacaoHistorico(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.REALINHAMENTO.HISTORICO.SET_PAGINACAO_LISTAGEM, paginacao)
			await this.carregarHistoricos()
		},
		getFornecedorDescricaoCompleta(item) {
			return `${this.$options.filters.azCpfCnpj(item.documento)} - ${item.razaoSocial}`
		},
	},
}
</script>
